import { render, staticRenderFns } from "./ActRequests.vue?vue&type=template&id=28bdbf4c&"
import script from "./ActRequests.vue?vue&type=script&lang=js&"
export * from "./ActRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports